import { http } from '@/core/helpers/http.helper';
import { ApiResource } from './../../../models/api-resource.interface';
import { VideocallRoom } from './videocall-room.interface';
export class VideocallRoomService {
   async getVideocallRooms(teamId: number) {
      const response = await http.get<ApiResource<Array<VideocallRoom>>>(`/teams/${teamId}/videocall-rooms`);
      return response.data;
   }

   async getVideocallRoom() {
      throw Error('Method not implemented');
   }

   async postVideocallRoom(teamId: number, videocallRoom: VideocallRoom) {
      const response = await http.post<ApiResource<Array<VideocallRoom>>>(`/teams/${teamId}/videocall-rooms`, videocallRoom);
      return response.data;
   }

   async putVideocallRoom(teamId: number, videocallRoom: VideocallRoom) {
      const response = await http.put<ApiResource<Array<VideocallRoom>>>(
         `/teams/${teamId}/videocall-rooms/${videocallRoom.id}`,
         videocallRoom,
      );
      return response.data;
   }

   async deleteVideocallRoom(teamId: number, videocallRoomId: number) {
      const response = await http.delete<ApiResource<Array<VideocallRoom>>>(`/teams/${teamId}/videocall-rooms/${videocallRoomId}`);
      return response.data;
   }
}
